import type { Team } from 'v2/types/api/conversations'
import { pluralize } from '@shared/utils'
import { TransferButtons } from './transfer-buttons'

interface TeamItemProps {
  team: Team
  onTransfer: (type: 'warm' | 'cold') => void
  isDisabled: boolean
}

export const TeamItem = ({ team, onTransfer, isDisabled }: TeamItemProps) => (
  <div className="flex items-center p-2 overflow-hidden gap-2 group cursor-default hover:bg-accent rounded-md border-b border-b-st2 last:border-b-0">
    <div className="flex flex-col overflow-hidden">
      <div className="text-p-400 truncate">{team.name}</div>
      <div className="text-s-400 text-tertiary">{pluralize(team.agent_count, 'agent')}</div>
    </div>
    <TransferButtons onTransfer={onTransfer} isDisabled={isDisabled} prefix="team-" />
  </div>
)
